import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { baseUrl, mainBaseUrl } from "../App";
import "./Styles/CertificateDetails.scss";
import { htmlContent } from "./HtmlContent";

const CertificateDetails = () => {
  const location = useLocation();
  const certificatePool = location.state.cert;
  const isAdmin = location.state.admin;
  const [info, setInfo] = useState([]);
  const [toggle, setTogge] = useState(false);

  const getNames = () => {
    if (toggle === false) {
      certificatePool["certificates"].map((cer) => {
        setInfo((oldArray1) => [...oldArray1, cer]);
      });
      setTogge(true);
    } else {
      setInfo("");
      setTogge(false);
    }
  };

  // const mailAgain = (certiID) => {
  //   axios
  //     .get(`${mainBaseUrl}/sendCertificate/${certiID}`, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         "API-Key": baseUrl,
  //       },
  //     })
  //     .then(() => alert("Mail sent successfully"))
  //     .catch((e) => alert(e.response.statusText));
  // };

  const sendEmailAgain = async ({ email }) => {
    var data = JSON.stringify({
      server_id: "6187e0a1992b2173634847a0",
      name: "event.admin@gdscghrce.dev",
      to: [email],
      cc: [`${location.state.profile}`],
      bcc: ["31aniket.singh@gmail.com", "paturkarr@gmail.com"],
      subject: `Here's your certificate for ${certificatePool["eventName"]} | GDSC GHRCE`,
      html_body: htmlContent({
        eventname: certificatePool["eventName"],
        id: certificatePool["eventID"],
      }),
    });

    var config = {
      method: "post",
      url: "https://gdscghrce-email-gateway.deta.dev/v1/api/mail/sendMail",
      headers: {
        accept: "application/json",
        "API-KEY": baseUrl,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")} `,
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
      })
      .catch(function (error) {
        console.log(error.response);
        console.log("call failed");
        // sendEmail(emailList);
      });
  };

  return (
    <div className="certificate-details">
      <div className="event-info">
        <div className="partOne">
          <p>
            <b>Event description: </b> {certificatePool["description"]}
          </p>
          <p>
            <b>Event Date: </b> {certificatePool["eventDate"]}
          </p>
          <p>
            <b>Event ID: </b> {certificatePool["eventID"]}
          </p>
          <p>
            <b>Event Name: </b> {certificatePool["eventName"]}
          </p>
          <p>
            <b>Publisher Name:</b> {certificatePool["publishedBy"]["name"]}
          </p>
          <p>
            {" "}
            <b>Publisher Email: </b>
            {certificatePool["publishedBy"]["email"]}
          </p>
          <p>
            <b>Speaker Name: </b> {certificatePool["speakerName"]}
          </p>

          <p>
            <b>Verified: </b> {certificatePool["verified"] ? "Yes" : "Pending"}
          </p>

          <p>
            <b>Total Certificates: </b>
            {certificatePool["certificates"].length}
          </p>
        </div>
        <div className="partTwo">
          <p>
            <b>Rejected: </b> {certificatePool["rejected"] ? "Yes" : "No"}
          </p>
          <p>
            <b>Rejected By: </b>
            {certificatePool["rejectedBy"] === undefined
              ? "Not Yet Rejected"
              : certificatePool["rejectedBy"]["name"]}
          </p>
          <p>
            <b>Rejected By(Email): </b>
            {certificatePool["rejectedBy"] === undefined
              ? "Not Yet Rejected"
              : certificatePool["rejectedBy"]["email"]}
          </p>
          <p>
            <b>Verified By: </b>
            {certificatePool["verifiedBy"] === undefined
              ? "Not Yet Verified"
              : certificatePool["verifiedBy"]["name"]}
          </p>
          <p>
            <b>Verifier's email: </b>
            {certificatePool["verifiedBy"] === undefined
              ? "Not Yet Verified"
              : certificatePool["verifiedBy"]["email"]}
          </p>
          <p>
            <b>Type Code: </b>
            {certificatePool["certificateTypeCode"]}
          </p>
          <p>
            <b>Type Code: </b>
            {certificatePool["certificateType"]}
          </p>
          <p>
            <b>Issue Date: </b>
            {certificatePool["certificateIssueDate"] ?? "Not yet verified"}
          </p>
        </div>

        <button onClick={getNames}>Click to get info</button>
      </div>
      {toggle ? (
        <div className="main-info-container">
          {info.map((infom, index) => {
            return (
              <div key={index} className="info-certi">
                <p>{infom["name"]}</p>
                <p>{infom["email"]}</p>
                <p>{infom["certificateID"]}</p>
                {certificatePool["verified"] ? (
                  <button
                    onClick={() => {
                      sendEmailAgain({ email: infom["email"] });
                    }}
                  >
                    Send Mail Again
                  </button>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default CertificateDetails;
